/**
 * API client configuration.
 *
 * Default is RELATIVE ('' base) — the browser calls the same origin it loaded
 * from, and nginx (frontend container) reverse-proxies /api and /media to the
 * backend. This is host-agnostic: it works whether you reach the app via
 * truenas.local, the NAS IP, or anything else, with no rebuild and no CORS.
 *
 * Set REACT_APP_API_URL only for a split deployment where the API lives on a
 * different origin (then CORS must allow it).
 */
const API_BASE = process.env.REACT_APP_API_URL || '';

export function getApiBaseUrl() {
  return API_BASE.replace(/\/$/, '');
}

export function apiUrl(path) {
  const base = getApiBaseUrl();
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

/**
 * Resolve a media URL. Absolute http(s) URLs (remote CDNs) pass through;
 * relative "/media/..." paths are resolved against the backend origin
 * (the backend is a different origin than the frontend in dev).
 */
export function mediaUrl(u) {
  if (!u) return u;
  if (/^https?:\/\//i.test(u)) return u;
  return apiUrl(u);
}
